/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultTagDto } from '../../models/api-response-paged-result-tag-dto';
import { PagedRequestTagDto } from '../../models/paged-request-tag-dto';

export interface SearchTags$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestTagDto
}

export function searchTags(http: HttpClient, rootUrl: string, params: SearchTags$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultTagDto>> {
  const rb = new RequestBuilder(rootUrl, searchTags.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultTagDto>;
    })
  );
}

searchTags.PATH = '/v1/api/products/tags/search';
